import { NgModule } from '@angular/core';

//******************************************************************************
//  Import Core Components
//******************************************************************************
import { CoreImports } from '~/core/classes/imports/core.imports';

//******************************************************************************
//  Import External Components
//******************************************************************************
import { ExternalImports } from '~/classes/imports/external.imports';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'


//******************************************************************************
//  Services
//******************************************************************************

//******************************************************************************
//  Pages
//******************************************************************************
import { HomeComponent } from '~/pages/home/home.component';
import { WellDetailComponent } from '~/pages/well-detail/well-detail.component';
import { WellsDataTabComponent } from '~/pages/home/wells-data-tab/wells-data-tab.component';
import { WellPrepareComponent } from '~/pages/well-prepare/well-prepare-component';
import { WellsRequestsTabComponent } from '~/pages/home/wells-requests-tab/wells-requests-tab.component';

import { DataComponent } from '~/pages/data/data.component';
import { BuSelectionComponent } from '~/pages/bu-selection/bu-selection.component';
import { ApprovalFlowComponent } from '~/pages/approval-flow/approval-flow.component';

//******************************************************************************
//  App Components
//******************************************************************************
import { WellsSchemaEditorComponent } from '~/components/wells-schema-editor/wells-schema-editor.component';
import { ReviewChangesComponent } from '~/components/review-changes/review-changes.component';
import { BulkUploadComponent } from '~/components/bulk-upload/bulk-upload.component';
import { NotificationComponent } from '~/shared/notification/notification.component';
import { ConfirmationDialogComponent } from '~/shared/confirmation-dialog/confirmation-dialog.component';
import { FullscreenLoadingComponent } from '~/shared/fullscreen-loading/fullscreen-loading.component';
import { CustomDropdownComponent } from '~/components/custom-dropdown/custom-dropdown.component';
import { FillCommentsComponent } from '~/components/fill-comments/fill-comments.component';
// import { ApiTestComponent } from '~/components/api-test/api-test.component';

//******************************************************************************
//  Pipes
//******************************************************************************
import { SafePipe } from '~/core/pipes/safe.pipe';

const components: any[] = [
    HomeComponent,
    WellDetailComponent,
    WellPrepareComponent,
    BuSelectionComponent,
    WellsDataTabComponent,
    WellsRequestsTabComponent,
    ApprovalFlowComponent,
    
    DataComponent,
    WellsSchemaEditorComponent,
    ReviewChangesComponent,
    BulkUploadComponent,
    NotificationComponent,
    ConfirmationDialogComponent,
    FullscreenLoadingComponent,
    FillCommentsComponent,
    // ApiTestComponent,
];

const services: any[] = [
];

@NgModule({
    imports: [
        CoreImports,
        ExternalImports,
        BrowserAnimationsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatInputModule,
        MatIconModule,
        MatMenuModule,
        CustomDropdownComponent
    ],
    declarations: [
        components,
        SafePipe,
    ],
    exports: [
        components,
        CustomDropdownComponent
    ],
    providers: [
        services,
    ],
})

export class AppImports { }
